import React, { useRef } from 'react';
import { cn } from '../../lib/utils';

interface SpotCardProps {
  children: React.ReactNode;
  className?: string;
  tilt?: boolean;
}

/**
 * Tarjeta con efecto "spotlight" (halo que sigue el cursor) y tilt 3D sutil.
 * --mx/--my se actualizan directo sobre el DOM (sin re-render) para que el
 * seguimiento del cursor sea fluido.
 */
const SpotCard: React.FC<SpotCardProps> = ({ children, className, tilt = true }) => {
  const ref = useRef<HTMLDivElement>(null);

  const handlePointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    el.style.setProperty('--mx', `${px * 100}%`);
    el.style.setProperty('--my', `${py * 100}%`);
    if (tilt) {
      el.style.transform = `perspective(760px) rotateY(${(px - 0.5) * 5}deg) rotateX(${-(py - 0.5) * 5}deg) translateY(-4px)`;
    }
  };

  const handlePointerLeave = () => {
    const el = ref.current;
    if (!el) return;
    if (tilt) el.style.transform = '';
  };

  return (
    <div
      ref={ref}
      onPointerMove={handlePointerMove}
      onPointerLeave={handlePointerLeave}
      className={cn('group relative transition-transform duration-300 will-change-transform', className)}
      style={{ ['--mx' as any]: '50%', ['--my' as any]: '50%' }}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-[inherit] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background: 'radial-gradient(circle at var(--mx) var(--my), rgba(255,255,255,.10), transparent 45%)',
        }}
      />
      {children}
    </div>
  );
};

export default SpotCard;
